import type { FaireProductEntity } from "../../entity_types/product";

export const p_z47ea3tazj: FaireProductEntity = {
  token: "p_z47ea3tazj",
  type: "product",
  name: "Olive Sticky Notes",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/df9ec98fd818a0354adc6b9ea3d3e73fecf64184b257a7ac4686f20fdd2efe91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd96e18f505c634c0b5d3e91e9835ea0cf87cfc5495f39b3a2cac9123195e25d.jpeg",
    "https://cdn.faire.com/fastly/7921cbac3e4c2474b4685cc530227807ae9779b1ee91388c6b4cca046e791e83.jpeg",
    "https://cdn.faire.com/fastly/bd2b32b15941d3e075eafde682641b2d1e02ce9ec909097cb772b82058b364d2.jpeg"
  ],
  priceDollars: 4,
  description: "Serve up reminders, grocery lists, recipes & more on our Olive Notes Sticky Notes. Great for getting organized and bookmarking cookbooks. \n\nGood to know: \n\n * Iconic Olive design! \n * Stick & restick anywhere. \n * Measures 3in x 3in \n * 100% Recyclable ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:06.790Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
